module.exports = {"pageTitleText":"HTML页面","createText":"Create","groupName":"Group Name","htmlPageName":"Page Name","status":"Status","sections":{"essential":"Essential"},"isPresentHtmlPageFromLocal":"从节点回传HTML页面"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/htmlPage.json
// module id = JDSd
// module chunks = 3